import { formatCalendarDate } from '@/lib/utils/date';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import type { EncounterOut } from '../api/encounters-api';
import { encounterTypeColors } from '../constants';
import { PatientAvatar } from './PatientAvatar';

interface EncounterCardProps {
  encounter: EncounterOut;
  onClick: () => void;
}

export function EncounterCard({ encounter, onClick }: EncounterCardProps) {
  const encounterType = encounter.encounter_type ?? 'initial';
  const patientName = encounter.patient?.name ?? encounter.patient?.mrn ?? '—';

  return (
    <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={onClick}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <PatientAvatar name={encounter.patient?.name} />
            <div className="min-w-0">
              <p className="font-medium truncate">{patientName}</p>
              <p className="text-xs text-muted-foreground">{formatCalendarDate(encounter.encounter_date)}</p>
            </div>
          </div>
          <Badge
            variant="secondary"
            className={`text-xs capitalize shrink-0 ${encounterTypeColors[encounterType] ?? ''}`}>
            {encounterType}
          </Badge>
        </div>
        {encounter.clinician?.name && <p className="text-xs text-muted-foreground mt-2">{encounter.clinician.name}</p>}
      </CardContent>
    </Card>
  );
}
